// @ts-strict-ignore
import React, { useState } from 'react';
import { create, InstanceProps } from 'react-modal-promise';
import { ButtonReact } from 'common/components/button';
import { ModalReact, ModalType } from 'common/components/modal';
import { SelectReact } from 'common/components/select';
import { Section } from 'common/components/items-menu/types';
import { commaizeNumber } from 'common/util';
import { ButtonTheme } from 'common/components/button/constants';
import { ChangeEvent } from 'common/components/select/types';
import { SelectTheme } from 'common/components/select/constants';
import styles from './index.module.styl';
function CsvExportContent(props: Props) {
  const [selectedLimit, setSelectedLimit] = useState(props.limitChoices[0]);
  const onLimitChange = (ev: ChangeEvent<number>) => {
    setSelectedLimit(ev.detail.item.value);
  };
  const getLimitLabel = (limit: number) => {
    return "".concat(commaizeNumber(limit.toString()), " rows");
  };
  const sections: Array<Section<number>> = [{
    items: props.limitChoices.map(limit => {
      return {
        label: getLimitLabel(limit),
        value: limit
      };
    })
  }];
  return <div className={styles.content} data-sentry-component="CsvExportContent" data-sentry-source-file="index.tsx">
      <header className={styles.header}>Export CSV</header>
      <div className={styles.body}>
        <div className={styles.exportLabel}>Export up to</div>
        <SelectReact className={styles.exportSelect} theme={SelectTheme.Secondary} selectedOption={getLimitLabel(selectedLimit)} sections={sections} onChange={onLimitChange} data-sentry-element="SelectReact" data-sentry-source-file="index.tsx" />
        <div className={styles.exportDescription}>Depending on the row quantity, your export speed may vary.</div>
      </div>
      <footer className={styles.footer}>
        <ButtonReact theme={ButtonTheme.Tertiary} onClick={() => props.onReject()} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx">
          Cancel
        </ButtonReact>
        <ButtonReact theme={ButtonTheme.Primary} onClick={() => props.onResolve({
        limit: selectedLimit
      })} data-sentry-element="ButtonReact" data-sentry-source-file="index.tsx">
          Export CSV
        </ButtonReact>
      </footer>
    </div>;
}
export const CsvExportModal = (props: Props) => {
  return <ModalReact modalType={ModalType.Modal} open modalTitle={"Export CSV"} modalDescription={"Modal for customizing CSV export limit"} growToContent closeable onStackableClosed={() => props.onReject()} data-sentry-element="ModalReact" data-sentry-component="CsvExportModal" data-sentry-source-file="index.tsx">
      <CsvExportContent {...props} data-sentry-element="CsvExportContent" data-sentry-source-file="index.tsx" />
    </ModalReact>;
};
type CsvExportData = {
  limit: number;
};
type Props = {
  limitChoices: number[];
} & InstanceProps<CsvExportData>;
export const promptCsvExportModal = create(CsvExportModal);